import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  showType?: boolean;
}

export default function MovieCard({ movie, showType = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={movie.cover}
          alt={`${movie.title} 影视作品海报`}
          title={`${movie.title} - 影视介绍与影评`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-[11px] font-medium backdrop-blur">
          {movie.type === "movie" ? "电影" : "剧集"}
        </span>
        <span className="absolute bottom-2.5 right-2.5 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-semibold">
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
          {showType && <span>{movie.year}</span>}
          <span className="text-background-400">·</span>
          <span className="truncate">{movie.region}</span>
          <span className="text-background-400">·</span>
          <span className="truncate">{movie.genres[0]}</span>
        </div>
      </div>
    </Link>
  );
}